import { createReadonlyProvider } from 'apprise-frontend-core/state/factory'


export type StreamConfiguration = {

    uploadTimeout: number 
}


export const [StreamConfigProvider, useStreamConfig] = createReadonlyProvider<StreamConfiguration>({

    uploadTimeout: 1000 * 60 * 1  // one minute
})